"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactPlayerLoader = _interopRequireDefault(require("@brightcove/react-player-loader"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

/* eslint-disable no-console */
var BrightcovePlayer = function BrightcovePlayer(props) {
  var accountId = props.accountId,
      classNames = props.classNames,
      videoId = props.videoId,
      brightcoveplayer = props.brightcoveplayer;

  var sendAnalyticsEvent = function sendAnalyticsEvent(eventName) {
    var thdAnalyticsEvent = {
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: eventName
      },
      video: {
        id: videoId,
        type: window.digitalData.page.pageInfo.pageType
      }
    };
    if (window.ddoEventInit) window.ddoEventInit(thdAnalyticsEvent);else console.log('Could not send analytics event.', thdAnalyticsEvent);
  };

  var onSuccess = function onSuccess(_ref) {
    var player = _ref.ref;
    player.one('play', function () {
      return sendAnalyticsEvent('video start');
    }); // Recomended in docs instead of first play event

    player.on('ended', function () {
      return sendAnalyticsEvent('video complete');
    });
  };

  var onFailure = function onFailure(failure) {
    console.log(failure);
  };

  return /*#__PURE__*/_react["default"].createElement(_reactPlayerLoader["default"], {
    accountId: accountId,
    playerId: brightcoveplayer,
    onSuccess: onSuccess,
    onFailure: onFailure,
    attrs: {
      className: classNames.join(' ')
    },
    videoId: videoId,
    embedOptions: {
      responsive: {
        aspectRatio: '16:9',
        maxWidth: '900px'
      }
    }
  });
};

BrightcovePlayer.propTypes = {
  /** GCC's account Id on Brightcove. */
  accountId: _propTypes.string,

  /** Used to set attributes on the component element that contains the embedded Brightcove Player. */
  classNames: (0, _propTypes.arrayOf)(_propTypes.string),

  /** Brightcove video ID. */
  videoId: _propTypes.string,

  /** Brightcove player ID. */
  brightcoveplayer: _propTypes.string
};
BrightcovePlayer.defaultProps = {
  accountId: '6248889401001',
  classNames: [],
  videoId: null,
  brightcoveplayer: 'NFnZhnSNG'
};
BrightcovePlayer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BrightcovePlayer",
  "props": {
    "accountId": {
      "defaultValue": {
        "value": "'6248889401001'",
        "computed": false
      },
      "description": "GCC's account Id on Brightcove.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "classNames": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "Used to set attributes on the component element that contains the embedded Brightcove Player.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "videoId": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Brightcove video ID.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "brightcoveplayer": {
      "defaultValue": {
        "value": "'NFnZhnSNG'",
        "computed": false
      },
      "description": "Brightcove player ID.",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = BrightcovePlayer;
exports["default"] = _default;